import React from 'react';
import { ResetPasswordApplyForm } from '../../components/Form/Password';
import { CommonResetPassword } from './CommonResetPassword';

export const ResetPasswordApply: React.FC = () => (
  <CommonResetPassword title="resetPasswordApply">
    <ResetPasswordApplyForm />
  </CommonResetPassword>
);
